var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DownOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
var ExpandableTableRow = function (_a) {
    var _b;
    var data = _a.data, columns = _a.columns, childLevel = _a.childLevel, childDataKey = _a.childDataKey, collapseAllEvent = _a.collapseAllEvent, hideChildren = _a.hideChildren, rowKey = _a.rowKey, rowColor = _a.rowColor, visibleOnInit = _a.visibleOnInit, expandParent = _a.expandParent;
    var _c = useState(true), collapsed = _c[0], setCollapsed = _c[1];
    var _d = useState(true), hidden = _d[0], setHidden = _d[1];
    var expand = visibleOnInit && visibleOnInit(data)
        ? function () { }
        : function () {
            setCollapsed(false);
            setHidden(false);
            expandParent();
        };
    var collapseIconClasses = "icon-button ".concat(collapsed ? "collapsed" : "");
    var childLevelClasses = "child-".concat(childLevel);
    var trClasses = "expandableRow ".concat(hidden && childLevel !== 0 ? "displayNone" : "", " ");
    var trStyles = rowColor && rowColor(data) ? { backgroundColor: rowColor(data) } : {};
    useEffect(function () {
        if (visibleOnInit && visibleOnInit(data)) {
            expandParent();
        }
    }, []);
    useEffect(function () {
        if (hidden) {
        }
        if (!hidden && !collapsed) {
            setHideRowChildren({ collapse: false, timestamp: Date.now() });
        }
    }, [hidden]);
    useEffect(function () {
        if (typeof collapseAllEvent.collapse == "boolean") {
            setCollapsed(collapseAllEvent.collapse);
            if (collapseAllEvent.collapse) {
                setHidden(true);
            }
            else {
                setHidden(false);
            }
        }
    }, [collapseAllEvent]);
    useEffect(function () {
        if (typeof hideChildren.collapse == "boolean") {
            if (hideChildren.collapse) {
                setHidden(true);
                setHideRowChildren(hideChildren);
            }
            else {
                setHidden(false);
            }
        }
    }, [hideChildren]);
    var _e = useState({
        timestamp: 0,
        collapse: undefined
    }), hideRowChildren = _e[0], setHideRowChildren = _e[1];
    var childRows = (_b = data[childDataKey || "child"]) === null || _b === void 0 ? void 0 : _b.map(function (data) {
        var rowKeyValue = function () {
            if (rowKey) {
                return data[rowKey];
            }
            else {
                return childLevel + Object.values(data).join();
            }
        };
        return (_jsx(ExpandableTableRow, { collapseAllEvent: collapseAllEvent, columns: columns, data: data, childLevel: childLevel + 1, childDataKey: childDataKey, rowKey: rowKey, rowColor: rowColor, visibleOnInit: visibleOnInit, expandParent: expand, hideChildren: hideRowChildren }, rowKeyValue()));
    });
    var renderCollapse = function (rowData) {
        if (rowData.child && rowData.child.length > 0) {
            return (_jsx("button", __assign({ className: collapseIconClasses, onClick: function (e) {
                    setCollapsed(!collapsed);
                    if (!collapsed) {
                        setHideRowChildren({ collapse: true, timestamp: e.timeStamp });
                    }
                    else {
                        setHideRowChildren({ collapse: false, timestamp: e.timeStamp });
                    }
                } }, { children: _jsx(DownOutlined, {}, void 0) }), void 0));
        }
        else {
            return (_jsx("button", __assign({ className: "visHidden " + collapseIconClasses }, { children: _jsx(DownOutlined, {}, void 0) }), void 0));
        }
    };
    var renderTableDataContents = function (column) {
        var _a;
        if (typeof column.key == "string") {
            var className = typeof column.class == "string" ? column.class : (_a = column.class) === null || _a === void 0 ? void 0 : _a[0];
            return _jsx("span", __assign({ className: className }, { children: data[column.key] }), void 0);
        }
        else {
            return column.key.map(function (key, keyIndex) {
                var _a;
                if (data[key]) {
                    var className = typeof column.class == "string"
                        ? column.class
                        : (_a = column.class) === null || _a === void 0 ? void 0 : _a[keyIndex];
                    return (_jsx("span", __assign({ className: className }, { children: data[key] }), void 0));
                }
                return undefined;
            });
        }
    };
    var mapRowTd = function (rowKeyValue, index, column) {
        var childClasses;
        var collapse;
        var className;
        if (index === 0) {
            childClasses = childLevelClasses;
            collapse = renderCollapse(data);
            className = "row-background-first";
        }
        else if (index === columns.length - 1) {
            className = "row-background-last";
        }
        else {
            className = "row-background-middle";
        }
        return (_jsx("td", __assign({ className: childClasses }, { children: _jsx("div", __assign({ className: "row-underline" }, { children: _jsxs("div", __assign({ className: className, style: trStyles }, { children: [collapse, renderTableDataContents(column)] }), void 0) }), void 0) }), rowKeyValue + index));
    };
    var rowData = columns === null || columns === void 0 ? void 0 : columns.map(function (column, index, arr) {
        var rowKeyValue = function () {
            if (rowKey) {
                return data[rowKey];
            }
            else {
                return childLevel + Object.values(data).join();
            }
        };
        return mapRowTd(rowKeyValue(), index, column);
    });
    var key = typeof columns[0].key == "string" ? columns[0].key : columns[0].key[0];
    return (_jsxs(_Fragment, { children: [_jsx("tr", __assign({ className: trClasses }, { children: rowData }), childLevel + data[key]), childRows] }, void 0));
};
export default ExpandableTableRow;
//# sourceMappingURL=ExpandableTableRow.js.map